import { render, staticRenderFns } from "./printApprovements.vue?vue&type=template&id=63908696&scoped=true"
import script from "./printApprovements.vue?vue&type=script&lang=js"
export * from "./printApprovements.vue?vue&type=script&lang=js"
import style0 from "./printApprovements.vue?vue&type=style&index=0&id=63908696&prod&lang=scss&scoped=true"
import style1 from "./printApprovements.vue?vue&type=style&index=1&id=63908696&prod&scoped=true&lang=css"
import style2 from "./printApprovements.vue?vue&type=style&index=2&id=63908696&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63908696",
  null
  
)

export default component.exports